/**
 * Shared constants for portfolio-sbi.
 */

/** Base URL of the main SmallBiz Innovation website. */
export const MAIN_SITE_URL = 'https://www.smallbizinnovation.com';
